import React, {lazy} from 'react';
import {Layout, Space} from "antd";
import LanguageSelector from "./page/main/component/LanguageSelector";
import Footer from "./page/main/component/Footer";
import {Content, Header} from 'antd/lib/layout/layout';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'

const MainPage = lazy(() => import("./page/main/MainPage"));
const Order = lazy(() => import("./page/order/OrderPage"));

function App() {
    return (
        <>
            <Layout style={{textAlign: "center", minHeight: "100vh"}}>
                <Header
                    style={{
                        paddingLeft: 0,
                        paddingRight: 0,
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        width: '100%',
                        borderBottom: "2px solid #f0f0f0",
                        backgroundColor: "whitesmoke"
                    }}
                >
                    <Space direction={"horizontal"} size={"middle"}>
                        <div><a href="/" style={{color: "#B99095"}}>L'Atelier de Macaron</a></div>
                        <LanguageSelector/>
                    </Space>
                </Header>

                <Content>
                    <Router>
                        <Routes>
                            <Route path="/order" element={<Order/>}/>
                            <Route path="/" element={<MainPage/>}/>
                        </Routes>
                    </Router>
                </Content>

                <Footer/>
            </Layout>
        </>
    );
}

export default App;
